module.exports = __webpack_public_path__ + "static/media/video.ecf94228.mp4";